import React, { Component } from 'react';

import { translate } from "react-translate";

import MenuComponent from '../MenuComponent';
import FooterComponent from '../FooterComponent';

import { Button, Segment, Image, Header, Container, Divider, Grid } from 'semantic-ui-react';
import './artisans.css';

import imageCgu from '../../../assets/img/faq.png';
import iphone from '../../../assets/img/iphone.png';
import logo from '../../../assets/img/logo_monstock.png';

class ArtisansComponent extends Component {


    render() {

        const { t } = this.props;


        return (
            <div>
                <MenuComponent />
                <Segment vertical id="sectionArtisans">
                    <Image
                        src={imageCgu}
                        id="sectionArtisansImage"
                        fluid />
                    <div id="containerArtisans">
                        <Container textAlign='center'>
                            <Header size='huge' as='h1' id="containerArtisansTitre">{t("Segment1_title")}</Header>
                        </Container>

                        <Container textAlign='center'>
                            <p id="containerArtisansDescription">
                                {t("Segment1_description")}
                            </p>
                        </Container>
                    </div>
                </Segment>

                <Segment vertical id="sectionArtisansContent">
                    <Grid stackable centered>
                        <Grid.Row columns={2}>
                            <Grid.Column mobile={16} tablet={8} computer={7} id="sectionArtisansContentFirstColumn">

                                        <Header size='huge' as='h3' id="sectionArtisansContentTitre">{t("Segment2_title")}</Header>
                                        <p id="sectionArtisansContentDescription">
                                            {t("Segment2_description1")}
                                        </p>
                                        <p id="sectionArtisansContentDescription">
                                            {t("Segment2_description2")}
                                        </p>
                                        <Button size='massive' id="sectionArtisansContentButton">{t("Segment2_button")}</Button>

                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={4} computer={3}>
                                    <Image centered src={iphone} id="sectionArtisansContentImage" />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>

                <Segment vertical id="monstock">
                <Container textAlign={'center'} >
                    <Segment inverted color='orange' id="externSegment">
                        <Segment textAlign="center" id="internSegment">
                            <Grid stretched stackable columns={2}>
                                <Grid.Column width={6}  textAlign="center" stretched id="monstockSegmentPicture"  >
                                    <Image centered src={logo}/>
                                </Grid.Column>
                                <Grid.Column width={10} textAlign="left" >
                                    <Header as="h3" id="monstockTitle">{t("Segment3_title")}</Header>
                                    <p id="monstockText">
                                        {t("Segment3_description")}
                                    </p>
                                    <Button circular compact id="monstockButton" >
                                      <a href="https://www.monstock.net/" target="_blank">{t("Segment3_button")}</a>
                                    </Button>
                                </Grid.Column>
                            </Grid>
                        </Segment>
                    </Segment>
                </Container>
                </Segment>


                {/* <Segment vertical id="monstock">
                    <Segment vertical id="monstockSegmentContent">
                        <Grid stackable columns={1}>
                            <Grid.Column textAlign="center">
                                <Segment id="monstockSegment" textAlign="center">
                                    <Grid stackable columns={2}>
                                        <Grid.Column id="monstockSegmentPicture" width={4}>
                                            <Image verticalAlign="middle" id="monstockImage" centered src={logo}/>
                                        </Grid.Column>
                                        <Grid.Column textAlign="left" id="monstockText" >
                                            <Header as="h3">Besoin de gérer vos stocks ?</Header>
                                            <p>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam in sagittis purus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla at porttitor metus. Nulla suscipit turpis at varius dictum. Sed turpis velit, gravida eget neque vel, vehicula commodo purus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Aenean id molestie arcu. Nulla id nisi sed eros pulvinar consequat vel commodo dui. Suspendisse porttitor finibus porttitor. Praesent auctor metus vel metus placerat cursus. Maecenas augue ante, mattis non euismod quis, maximus at augue. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Aenean lobortis mollis aliquet.
                                            </p>
                                            <Button circular  id="monstockButton" >Découvrir</Button>
                                        </Grid.Column>
                                    </Grid>
                                </Segment>
                            </Grid.Column>
                        </Grid>
                    </Segment>
                </Segment> */}

                <FooterComponent />
            </div>
        );
    }
}

export default translate("ArtisansComponent")(ArtisansComponent);



// WEBPACK FOOTER //
// ./src/components/Public/ArtisansPage/ArtisansComponent.js